import { createSlice } from '@reduxjs/toolkit';
import GetPaginationQueryString from '../../utils/pageExtensions';
import Config from '../../config.js';

export const clientSlice = createSlice({
    name: 'client',
    initialState: {
        clients: []
    },
    reducers: {
        fetchClientByActivationCode: (state, action) => {
            fetch(Config.FHIRAPIUrl + 'CGClient/checkClient', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ActivationCode: action.payload.activationCode,
                    DateOfBirth: action.payload.dateOfBirth
                })
            })
                .then((response) => {
                    if (response.status === 204) {
                        return null;
                    }

                    if (!response.ok) {
                        const errorMessage = response.statusText;
                        throw new Error(errorMessage ? errorMessage : 'Failed to fetch client by Activation Code');
                    }

                    return response.json();
                })
                .then((response) => {
                    if (action.payload.callback)
                        action.payload.callback(response);
                })
                .catch((error) => {
                    if (action.payload.catch)
                        action.payload.catch(error);
                });
        },
        setClients: (state, action) => {
            state.clients = action.payload || [];
        }
    }
})

export const { setClients, fetchClientByActivationCode } = clientSlice.actions

export default clientSlice.reducer
